export default __webpack_public_path__ + "static/media/happyInvestParallax.81e41b5c.png";